import { hasReturnTickets } from '@pperform/pp-utils/parcelOrg';
import { useGlobalConfigContext } from 'GlobalConfig.context';
import Shipment from 'interfaces/PmParcel';
import { useEffect, useState } from 'preact/hooks';
import { ptpCatchError } from 'services/sentry.services';
import { userAuthService } from 'services/userAuth.services';
import { isRuntimeError } from 'utils/fetcher.utils';
import { evaluateShipment } from '../services';
import { mapLineItemEligibility } from '../utils';

export const useEvaluateShipmentEligibility = (
  shipment: Shipment,
  onUpdateShipment: (shipment: Shipment) => void,
  setError: (error: string) => void,
) => {
  const { organizationId, cmsReference } = useGlobalConfigContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isShipmentEligibleForReturn, setIsShipmentEligibleForReturn] =
    useState(false);
  const [nonEligibleLineItems, setNonEligibleLineItems] = useState<string[]>(
    [],
  );
  const shipmentHasReturnRequests = hasReturnTickets(shipment);

  useEffect(() => {
    // for case view return details, no need to evaluate shipment
    if (shipmentHasReturnRequests) {
      setIsShipmentEligibleForReturn(true);
      setIsLoading(false);
      return;
    }
    evaluateShipment(organizationId, shipment.poId, cmsReference)
      .then((data) => {
        const { isShipmentEligibleForReturn, nonEligibleLineItems } = data;
        setIsShipmentEligibleForReturn(isShipmentEligibleForReturn);
        setNonEligibleLineItems(nonEligibleLineItems);

        if (nonEligibleLineItems && userAuthService.isUserValidated()) {
          onUpdateShipment(
            mapLineItemEligibility(shipment, nonEligibleLineItems),
          );
        }
      })
      .catch((error) => {
        if (isRuntimeError(error)) {
          ptpCatchError(error);
        }
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    isLoading,
    isShipmentEligibleForReturn,
    nonEligibleLineItems,
  };
};
